<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" @click="exportPerformance()">导出绩效明细PDF</el-button>
      </template>
      <el-form inline>
        <!-- 按当班日期选择完整区间，支持跨月查询，包含起止当天。 -->
        <el-form-item label="当班日期"><el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false" @change="query" /></el-form-item>
        <el-form-item><el-button type="primary" @click="query">查询</el-button></el-form-item>
      </el-form>
    </custom-actions>
    <el-card class="mt10" shadow="never">
      <div class="summary"><div>总产量<strong>{{ totalQuantity }}</strong></div><div>总绩效<strong>{{ totalPerformance }}</strong></div></div>
    </el-card>
    <el-card class="mt10" shadow="never">
      <div slot="header">产品绩效汇总</div>
      <el-table :data="summaryData" border size="mini">
        <el-table-column label="产品名称" prop="specName" /><el-table-column label="产量" prop="totalQuantity" />
        <el-table-column label="绩效系数" prop="performanceCoefficient" /><el-table-column label="绩效" prop="totalPerformance" />
      </el-table>
    </el-card>
    <el-card class="mt10" shadow="never">
      <div slot="header">生产绩效明细</div>
      <el-table :data="tableData" v-loading="loading" border stripe size="mini">
        <el-table-column label="生产编号" prop="productionCode" min-width="180">
          <template #default="{ row }"><el-button type="text" @click="$router.push('/productrecord/detail?recordId=' + row.productionRecordId)">{{ row.productionCode }}</el-button></template>
        </el-table-column>
        <!-- 使用接口返回的真实当班日期，与查询口径保持一致。 -->
        <el-table-column label="当班日期" prop="shiftDate" min-width="110" />
        <el-table-column label="开机人" prop="startupOperator" min-width="120" show-overflow-tooltip />
        <el-table-column label="产品名称" prop="specName" min-width="150" show-overflow-tooltip />
        <el-table-column label="产量" prop="quantity" min-width="100" />
        <el-table-column label="绩效系数" prop="performanceCoefficient" min-width="100" />
        <el-table-column label="绩效" prop="performancePrice" min-width="100" />
        <el-table-column label="操作" width="260" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="$router.push('/productionPerformance/detail?id=' + row.id)">详情</el-button>
            <el-button v-if="hasEdit" type="text" @click="openEdit(row)">编辑绩效</el-button>
            <el-button v-if="hasDelete" type="text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mt15" :current-page.sync="page" :page-size="10" :total="total" layout="total, prev, pager, next" @current-change="loadList" />
    </el-card>
    <el-dialog title="编辑生产绩效" :visible.sync="editVisible" width="480px">
      <el-alert title="调整后当月绩效总额不能低于已填报的个人绩效金额。" type="info" :closable="false" />
      <el-form label-width="100px" class="mt15">
        <el-form-item label="编辑字段"><el-radio-group v-model="editForm.field"><el-radio label="coefficient">绩效系数</el-radio><el-radio label="price">绩效金额</el-radio></el-radio-group></el-form-item>
        <el-form-item v-if="editForm.field === 'coefficient'" label="绩效系数"><el-input-number v-model="editForm.performanceCoefficient" :min="0" :precision="3" /></el-form-item>
        <el-form-item v-else label="绩效金额"><el-input-number v-model="editForm.performancePrice" :min="0" :precision="2" /></el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="editVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="saveEdit">保存</el-button></div>
    </el-dialog>
  </div>
</template>
<script>
import keepAlive from '@/mixins/keepAlive'
import { exportFiles } from '@/utils/globalMethods'
export default {
  name: 'ProductionPerformance',
  mixins: [keepAlive],
  data() {
    return {
      // 默认查询本月当班记录，允许手动选择任意日期区间。
      dateRange: [this.$dayjs().startOf('month').format('YYYY-MM-DD'), this.$dayjs().endOf('month').format('YYYY-MM-DD')],
      page: 1,
      total: 0,
      tableData: [],
      summaryData: [],
      loading: false,
      saving: false,
      editVisible: false,
      editForm: {}
    }
  },
  computed: {
    productType() {
      return this.$route.query.productType
    },
    menuCode() {
      return this.productType === '1' ? 'JLSCJX' : 'SCJXTJ'
    },
    buttonList() {
      return this.$store.getters.getMenuByCode(this.menuCode)
    },
    // 权限取当前生产菜单，不依赖储运菜单或模式开关。
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    // 列表、汇总和PDF共用当班日期区间及车间类型，避免导出范围与页面不一致。
    filters() {
      return { startDate: this.dateRange[0], endDate: this.dateRange[1], productType: this.productType }
    },
    totalQuantity() { return this.summaryData.reduce((sum, row) => sum + Number(row.totalQuantity || 0), 0).toFixed(3) },
    totalPerformance() { return this.summaryData.reduce((sum, row) => sum + Number(row.totalPerformance || 0), 0).toFixed(2) }
  },
  watch: {
    productType(val, oldVal) {
      if (val && val !== oldVal) {
        this.tableData = []
        this.total = 0
        this.loading = false
        // 切换车间后恢复本月日期区间，并从第一页重新查询。
        this.dateRange = [this.$dayjs().startOf('month').format('YYYY-MM-DD'), this.$dayjs().endOf('month').format('YYYY-MM-DD')]
        this.query()
      }
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() { this.page = 1; return this.refresh() },
    refresh() { return Promise.all([this.loadList(), this.loadSummary()]) },
    async loadList() {
      this.loading = true
      try {
        const result = await this.$axios.get(this.$apis.productionPerformance.selectByPage, { ...this.filters, productType: this.productType, page: this.page, limit: 10 })
        this.tableData = result.list || []
        this.total = result.total || 0
      } finally { this.loading = false }
    },
    async loadSummary() { this.summaryData = await this.$axios.get(this.$apis.productionPerformance.selectSummary, { ...this.filters, productType: this.productType }) || [] },
    // 按当前条件导出生产总额，个人填报报表移至独立月份菜单。
    exportPerformance() {
      exportFiles(this.$apis.productionPerformance.exportPerformancePdf, this.filters, '长江粮油包装车间绩效明细表.pdf')
    },
    openEdit(row) {
      this.editForm = { id: row.id, field: 'coefficient', performanceCoefficient: Number(row.performanceCoefficient), performancePrice: Number(row.performancePrice) }
      this.editVisible = true
    },
    async saveEdit() {
      const field = this.editForm.field === 'coefficient' ? 'performanceCoefficient' : 'performancePrice'
      this.saving = true
      try {
        await this.$axios.post(this.$apis.productionPerformance.update, { id: this.editForm.id, [field]: this.editForm[field] })
        this.editVisible = false
        await this.refresh()
      } finally { this.saving = false }
    },
    async remove(row) {
      await this.$confirm('确认删除该生产绩效？当月总额不足时将阻止删除。', '提示', { type: 'warning' })
      await this.$axios.post(this.$apis.productionPerformance.delete, { id: row.id })
      if (this.tableData.length === 1 && this.page > 1) this.page--
      await this.refresh()
    }
  }
}
</script>
<style scoped lang="scss">
.summary { display: flex; gap: 20px; text-align: center; }
.summary > div { flex: 1; font-size: 18px; }
.summary strong { display: block; margin-top: 12px; font-size: 32px; color: #409eff; }
</style>
